import { useRef } from 'react';

/**
 * FindMyPhotosBar — prominent red-tinted AI face-search panel.
 * onSelfie() opens the webcam; onUpload(File) receives a reference photo.
 * Shared by PublicGallery and BrandedGallery (promoted above the toolbar).
 */
const FindMyPhotosBar = ({ onSelfie, onUpload }) => {
  const fileRef = useRef(null);

  return (
    <div style={{ padding: 'clamp(22px,3vw,34px) clamp(16px,3vw,38px) 0' }}>
      <div
        className="flex items-center justify-between gap-[18px] flex-wrap"
        style={{
          padding: 'clamp(14px,2vw,18px) clamp(16px,2vw,22px)',
          borderRadius: 12,
          background: 'linear-gradient(100deg, rgba(191,33,47,0.16), rgba(255,255,255,0.03))',
          border: '1px solid rgba(191,33,47,0.3)',
        }}
      >
        <div className="flex items-center gap-[14px] flex-1" style={{ minWidth: 240 }}>
          <div
            className="flex-shrink-0 flex items-center justify-center"
            style={{ width: 44, height: 44, borderRadius: 11, background: '#BF212F' }}
          >
            <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
              <circle cx="11" cy="11" r="7" />
              <path d="M21 21l-3.5-3.5" />
              <circle cx="11" cy="9.5" r="2" />
              <path d="M7.5 15c0.6-1.6 2-2.4 3.5-2.4s2.9 0.8 3.5 2.4" />
            </svg>
          </div>
          <div>
            <div className="flex items-center gap-[9px]">
              <span className="font-tiq-display text-white" style={{ fontWeight: 800, fontSize: 'clamp(15px,2vw,17px)' }}>
                Find my photos
              </span>
              <span
                className="tiq-ai-pill font-tiq-mono text-white"
                style={{ fontSize: 9, fontWeight: 700, letterSpacing: '0.06em', padding: '3px 7px', borderRadius: 5 }}
              >
                AI
              </span>
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginTop: 3 }}>
              Take a selfie or upload a photo — we'll find every shot you're in.
            </div>
          </div>
        </div>
        <div className="flex gap-[10px] flex-shrink-0">
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f && onUpload) onUpload(f);
              e.target.value = '';
            }}
          />
          <button
            onClick={() => fileRef.current?.click()}
            className="font-tiq-heading whitespace-nowrap"
            style={{
              padding: '11px 17px',
              borderRadius: 8,
              border: '1px solid rgba(255,255,255,0.22)',
              background: 'rgba(255,255,255,0.06)',
              color: '#fff',
              fontWeight: 600,
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Upload Reference Photo
          </button>
          <button
            onClick={onSelfie}
            className="font-tiq-heading whitespace-nowrap"
            style={{ padding: '11px 17px', borderRadius: 8, border: 'none', background: '#fff', color: '#0A0A0B', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
          >
            Take a selfie
          </button>
        </div>
      </div>
    </div>
  );
};

export default FindMyPhotosBar;
